"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@angular/material");
var router_1 = require("@angular/router");
var subscribtion_service_1 = require("./../../../Services/subscribtion.service");
var service_service_1 = require("src/app/Services/service.service");
var subscriptionInformation_component_1 = require("./../../../SubscriptionInformation/subscriptionInformation.component");
var SubscriptionInformationComponent = /** @class */ (function (_super) {
    __extends(SubscriptionInformationComponent, _super);
    function SubscriptionInformationComponent(mainService, subscribtionService, router, dialog) {
        var _this = _super.call(this, mainService, subscribtionService, router, dialog) || this;
        _this.mainService = mainService;
        mainService.pageName = "Subscription Information";
        return _this;
    }
    return SubscriptionInformationComponent;
}(subscriptionInformation_component_1.SubscriptionInformationComponent));
exports.SubscriptionInformationComponent = SubscriptionInformationComponent;
